import { page } from '$app/stores';
import type { Game } from '$lib/types';
import { get } from 'svelte/store';

export const getGameUrl = (game: Game): string => {
  const { pathname } = get(page).url;

  // check if `contentVideoContainerCount` exists first to avoid redirection from `/watch` to `/`
  //  which leads to run the load funtion on `/watch`
  // if not check pathname that ends with `/watch`
  if ((!!game?.contentVideoContainerCount && game?.contentVideoContainerCount > 0) || pathname.endsWith('/watch'))
    return `/${game.slug}/watch`;

  return `/${game.slug}`;
};
